export enum StandardDateFormat {
  FullDate = 'dd.MM.yyyy',
  DateTime = 'dd.MM.yyyy, HH:mm',
  Time = 'HH:mm',
}

export * from './date.functions';
export * from './date.types';
export * from './date.module';
